<div class="m-3">
  <div class="flex align-items-center gap-6">
    @if (isCorporateMode()) {
      <a class="footer-link" href="{{ 'shared.footer.dzbanking-url' | translate }}">
        {{ "shared.footer.dzbanking" | translate }}
      </a>
      <a class="footer-link" href="{{ 'shared.footer.imprint-fk-url' | translate }}">
        {{ "shared.footer.imprint-fk" | translate }}
      </a>
    } @else {
      <a class="footer-link" href="{{ 'shared.footer.vrbp-url' | translate }}">
        {{ "shared.footer.vrbp" | translate }}
      </a>
      <a class="footer-link" href="{{ 'shared.footer.imprint-url' | translate }}">
        {{ "shared.footer.imprint" | translate }}
      </a>
      <a class="footer-link" href="{{ 'shared.footer.terms-of-use-url' | translate }}">
        {{ "shared.footer.terms-of-use" | translate }}
      </a>
    }
    @if (userStore.loaded()) {
      <div class="ml-auto" id="footer-hotline">
        <i class="pi pi-phone mr-2"></i> {{ hotlineKey | translate }}
      </div>
    }
  </div>
</div>

<div class="ml-3 mb-3">
  <div class="flex align-items-center">
    <div>&copy; DZ BANK AG Deutsche Zentral-Genossenschaftsbank, Frankfurt am Main</div>
    @if (version) {
      <div class="version-info ml-auto mr-3">
        {{ version }}
      </div>
    }
  </div>
</div>
